module.exports = __FOREMAN_VENDOR__APOLLO_CLIENT_LINK_BATCH_HTTP__;